import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '../../StyledIconBase';
export var Times = React.forwardRef(function (props, ref) {
    var attrs = {
        "fill": "currentColor",
        "xmlns": "http://www.w3.org/2000/svg",
    };
    return (React.createElement(StyledIconBase, __assign({ iconAttrs: attrs, iconVerticalAlign: "middle", iconViewBox: "0 0 24 24" }, props, { ref: ref }),
        React.createElement("path", { d: "M17.414 6.586a2 2 0 00-2.828 0L12 9.172 9.414 6.586a2 2 0 10-2.828 2.828L9.171 12l-2.585 2.586a2 2 0 102.828 2.828L12 14.828l2.586 2.586c.39.391.902.586 1.414.586s1.024-.195 1.414-.586a2 2 0 000-2.828L14.829 12l2.585-2.586a2 2 0 000-2.828z", key: "k0" })));
});
Times.displayName = 'Times';
export var TimesDimensions = { height: 24, width: 24 };
